module.exports = {
      id: "close-usage",
      viewBox: "0 0 54 54",
      url: "/" + "sprite.67d9a3e87988b596c0329bae93bfba4b.svg#close",
      toString: function () {
        return this.url;
      }
    }